"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
exports.default = ({ helmetComponent, scriptSrc = "https://www.googletagmanager.com" }) => {
    const Helmet = helmetComponent;
    return ((0, jsx_runtime_1.jsx)(Helmet, { children: (0, jsx_runtime_1.jsx)("script", { children: `(function() {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                    const elements = document.getElementsByTagName('script')[0];
                    const script = document.createElement('script');
                    script.async = true;
                    script.onload = function () {return window.grebban.gtm.scriptCallback('GTM');}
                    script.src = '` +
                scriptSrc +
                `?id=' + window.grebban.gtm.trackingKey;
                    script.id = 'GTMScript';
                    elements.parentNode.insertBefore(script, elements);
                })()` }) }));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2NyaXB0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL1NjcmlwdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBT0Esa0JBQWUsQ0FBQyxFQUFFLGVBQWUsRUFBRSxTQUFTLEdBQUcsa0NBQWtDLEVBQWtCLEVBQUUsRUFBRTtJQUNuRyxNQUFNLE1BQU0sR0FBRyxlQUFlLENBQUM7SUFFL0IsT0FBTyxDQUNILHVCQUFDLE1BQU0sY0FDSCw2Q0FDSzs7Ozs7OzttQ0FPa0I7Z0JBQ2YsU0FBUztnQkFDVDs7O3FCQUdDLEdBQ0EsR0FDSixDQUNaLENBQUM7QUFDTixDQUFDLENBQUMifQ==